import { ProjectTemplate } from '../models/configs.model';

export function normalizeProjectTemplate(template: ProjectTemplate): ProjectTemplate {
  return {
    ...template,
    data: template.data.map((data) => ({
      ...data,
      code: data.code ? data.code : data.id,
    })),
  };
}
